(() => {
  const normalize = value => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const copyText = async value => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }
    const field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand('copy');
    field.remove();
    if (!copied) throw new Error('copy failed');
  };

  document.querySelectorAll('[data-apn-root]').forEach(root => {
    const search = root.querySelector('[data-apn-search]');
    const filters = [...root.querySelectorAll('[data-apn-filter]')];
    const cards = [...root.querySelectorAll('[data-apn-card]')];
    const groups = [...root.querySelectorAll('[data-apn-country-group]')];
    const results = root.querySelector('[data-apn-results]');
    const empty = root.querySelector('[data-apn-empty]');
    let activeCountry = 'all';

    const update = () => {
      const term = normalize(search?.value.trim() || '');
      let visibleCount = 0;
      cards.forEach(card => {
        const countryMatches = activeCountry === 'all' || card.dataset.country === activeCountry;
        const textMatches = !term || normalize(`${card.dataset.search || ''} ${card.textContent}`).includes(term);
        card.hidden = !(countryMatches && textMatches);
        if (!card.hidden) visibleCount += 1;
      });
      groups.forEach(group => {
        group.hidden = ![...group.querySelectorAll('[data-apn-card]')].some(card => !card.hidden);
      });
      if (empty) empty.hidden = visibleCount !== 0;
      if (results) results.textContent = visibleCount === 1 ? '1 Anbieter oder Variante wird angezeigt.' : `${visibleCount} Anbieter und Varianten werden angezeigt.`;
    };

    filters.forEach(button => button.addEventListener('click', () => {
      activeCountry = button.dataset.apnFilter;
      filters.forEach(item => item.classList.toggle('is-active', item === button));
      update();
    }));
    search?.addEventListener('input', update);

    root.querySelectorAll('[data-copy-apn]').forEach(button => button.addEventListener('click', async () => {
      const command = button.closest('[data-apn-card]')?.querySelector('code')?.textContent.trim();
      if (!command) return;
      const originalLabel = button.textContent;
      button.classList.remove('is-copied', 'is-error');
      try {
        await copyText(command);
        button.textContent = 'Kopiert ✓';
        button.classList.add('is-copied');
      } catch (error) {
        button.textContent = 'Bitte Befehl markieren';
        button.classList.add('is-error');
      }
      window.setTimeout(() => {
        button.textContent = originalLabel;
        button.classList.remove('is-copied', 'is-error');
      }, 2600);
    }));
  });
})();
